export const RECORD_NETWORK_DELAY = 'web-config/RECORD_NETWORK_DELAY'
export const RESET_NETWORK_DELAY = 'web-config/RESET_NETWORK_DELAY'
